import React from "react";
import { AiFillInstagram } from "react-icons/ai";
import { FaDiscord, FaGithub } from "react-icons/fa";
import { SiBuymeacoffee } from "react-icons/si";

const Footer = () => {
  return (
    <div className="footer-container">
      <p>2022 Elitex Car dealership All rights reserved</p>
      <p className="icons">
        <AiFillInstagram />
        {/* <a href="https://github.com/jsvigneshkanna/elitex_car_catalogue_reactjs" target="blank">
          <FaGithub />
        </a> */}
        <a href="https://discord.com/channels/784794493580476436/1022406355371442267" target="blank">
          <FaDiscord />
        </a>
        <FaGithub />

        <a href="https://www.buymeacoffee.com/jsvigneshkanna" target="blank">
          <SiBuymeacoffee />
        </a>
      </p>
    </div>
  );
};

export default Footer;
